<div
  class="age-vericifacation-container"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <div class="age-verification-wrap d-flex flex-column align-items-center">
    <h1>{{ "AGE_VERIFICATION.TITLE" | translate }}</h1>
    <mat-card
      class="age-verification-card"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <ng-container
        *ngIf="underage; then thenTemplate; else elseTemplate"
      ></ng-container>
      <ng-template #thenTemplate>
        <p>
          {{ "AGE_VERIFICATION.UNDERAGE_WARNING" | translate }}
        </p>
      </ng-template>
      <ng-template #elseTemplate>
        <p>
          {{ "AGE_VERIFICATION.DIALOG.TITLE" | translate }}
        </p>
        <div class="button-wrap" fxLayout="column" fxLayoutGap="10px">
          <button mat-raised-button (click)="onVerify()">
            {{ "AGE_VERIFICATION.DIALOG.YES" | translate }}</button
          ><button mat-raised-button (click)="onReject()">
            {{ "AGE_VERIFICATION.DIALOG.NO" | translate }}
          </button>
        </div>
      </ng-template>
    </mat-card>
  </div>
</div>
